/* src/app/core/footer/footer.component.scss */
/*# sourceMappingURL=footer.component-3XIL4GCN.css.map */
